export default __webpack_public_path__ + "static/media/DBT_User_Guide_April2021.420e486a.pdf";